import { createContext, useContext } from 'react';
import type { PublicUser } from '../api/types.js';

export interface AuthState {
  /** `null` — не вошёл; `undefined` невозможен: до готовности рисуется загрузка. */
  readonly user: PublicUser | null;
  /** Идёт восстановление сессии после загрузки страницы. */
  readonly isBootstrapping: boolean;
  /** Сервер временно недоступен; refresh будет повторён автоматически. */
  readonly isReconnecting: boolean;
  login(email: string, password: string): Promise<void>;
  logout(): Promise<void>;
  /** Обновить пользователя в контексте, например после подтверждения почты. */
  setUser(user: PublicUser | null): void;
}

export const AuthContext = createContext<AuthState | null>(null);

export function useAuth(): AuthState {
  const value = useContext(AuthContext);
  if (!value) {
    throw new Error('useAuth вызван вне AuthProvider');
  }
  return value;
}
